import { render } from "./NuovaPrenotazionePage.vue?vue&type=template&id=bedde8d2&scoped=true"
import script from "./NuovaPrenotazionePage.vue?vue&type=script&lang=js"
export * from "./NuovaPrenotazionePage.vue?vue&type=script&lang=js"

import "./NuovaPrenotazionePage.vue?vue&type=style&index=0&id=bedde8d2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bedde8d2"]])

export default __exports__